import React, { useState } from 'react';
import deactivationApi from '../services/deactivationApi';
import '../styles/deactivateAccount.css';

export default function DeactivateAccount() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    store_name: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [responseData, setResponseData] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');
    setResponseData(null);

    try {
      // Validate form data
      if (!formData.name || !formData.phone || !formData.store_name) {
        setError('All fields are required');
        setLoading(false);
        return;
      }

      const response = await deactivationApi.requestDeactivation(formData);
      
      if (response.success) {
        setMessage(response.message);
        setResponseData(response.data);
        setFormData({ name: '', phone: '', store_name: '' });
      }
    } catch (err) {
      setError(err.message || 'Failed to deactivate account. Please try again.');
      console.error('Deactivation error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="deactivate-container">
      <div className="deactivate-card">
        <h1>Request Account Deactivation</h1>
        <p className="deactivate-description">
          Fill in the details below to request deactivation of your store account.
        </p>

        <form onSubmit={handleSubmit} className="deactivate-form">
          <div className="form-group">
            <label htmlFor="name">Full Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your full name"
              disabled={loading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number *</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter your phone number"
              disabled={loading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="store_name">Store Name *</label>
            <input
              type="text"
              id="store_name"
              name="store_name"
              value={formData.store_name}
              onChange={handleChange}
              placeholder="Enter your store name"
              disabled={loading}
              required
            />
          </div>

          {error && (
            <div className="alert alert-error">
              {error}
            </div>
          )}

          {message && (
            <div className="alert alert-success">
              {message}
            </div>
          )}

          <button 
            type="submit" 
            className="submit-btn"
            disabled={loading}
          >
            {loading ? 'Processing...' : 'Request Deactivation'}
          </button>
        </form>

        {responseData && (
          <div className="response-data">
            <h3>Deactivation Request Details:</h3>
            <table className="response-table">
              <tbody>
                <tr>
                  <td><strong>ID:</strong></td>
                  <td>{responseData.id}</td>
                </tr>
                <tr>
                  <td><strong>UID:</strong></td>
                  <td>{responseData.uid}</td>
                </tr>
                <tr>
                  <td><strong>Name:</strong></td>
                  <td>{responseData.name}</td>
                </tr>
                <tr>
                  <td><strong>Phone:</strong></td>
                  <td>{responseData.phone}</td>
                </tr>
                <tr>
                  <td><strong>Store Name:</strong></td>
                  <td>{responseData.store_name}</td>
                </tr>
                <tr>
                  <td><strong>Created At:</strong></td>
                  <td>{new Date(responseData.created_at).toLocaleString()}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
